module.exports = [
    { key: 0, label: 'Users' },
    { key: 1, label: 'Block Users' },
    { key: 2, label: 'Authorize Users' },
    // { key: 3, label: 'Search Users' }
];
